import React, {useEffect, useState} from 'react';
import IntlMessage, {IntlMessageText} from "../../../../../components/IntlMessage/IntlMessage";
import {useDispatch, useSelector} from "react-redux";
import {changeCurrentPage} from "../../../../../store/slices/tableController/MicroQualificationListTableController";
import MyText from "../../../../../components/UI/Text/MyText";
import {Flex, Form, Input, message, Modal} from "antd";
import MyTable from "../../../../../components/Table/MyTable";
import {getAllMicroQualifications} from "../../../../../store/slices/MicroqualificationsSlice";
import {LocalName} from "../../../../../utils/LocalName";
import {useNavigate} from "react-router-dom";
import classes from "../../Applications/application.module.css";
import MicroQualificationService from "../../../../../services/MicroQualificationService";
import {useTranslation} from "react-i18next";
import BlackerBlueButton from "../../../../../components/UI/Buttons/BlackerBlueButton";
import FormItem from "antd/es/form/FormItem";

const MicroQualificationList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const {t} = useTranslation();

    const nameRu = Form.useWatch('nameRu', form);
    const nameKz = Form.useWatch('nameKz', form);
    const nameEng = Form.useWatch('nameEng', form);

    const {microQualifications, isLoading, hasMore, error} = useSelector(state => state.microQualificationList)
    const {currentPage, pageSize} = useSelector(state => state.microQualificationListTableController);

    const [isLoadingCreate, setIsLoadingCreate] = useState(false);
    const [openModal, setOpenModal] = useState(false)

    const columns = [
        {
            title: <MyText center strong><IntlMessage id={"educationField"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.educationField)}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"trainingDirection"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.trainingDirection)}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"groupEP"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.groupEP)}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"microQEP"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.name)}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"partnerOrg"}/></MyText>,
            render: (_, record) => (
                <MyText center>{LocalName.getName(record.partnerOrg)}</MyText>
            ),
            width: '15%',
        },
        {
            title: <MyText center strong><IntlMessage id={"mEditor"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record?.fullName}</MyText>
            ),
            width: '10%',
        },
        {
            title: <MyText center strong><IntlMessage id={"actions"}/></MyText>,
            render: (_, record) => (
                <>
                    <Flex style={{width: "100%"}} align={"center"} justify={"center"} wrap={"wrap"} gap={20}>
                        <p onClick={() => navigate(`/p/microqualification/${record.id}/view`)}
                           className={classes.copyLinkBtn}>
                            <IntlMessage id={'view'}/>
                        </p>
                        <p onClick={() => downloadDocument(record.id)}
                           className={classes.historyEventsBtn}>
                            <IntlMessage id={'download'}/>
                        </p>
                        <p onClick={() => downloadDocument(record.id)}
                           className={classes.copyLinkBtn}>
                            <IntlMessage id={'changeStatus'}/>
                        </p>
                    </Flex>
                </>
            ),
            width: '15%',
        },
    ];

    useEffect(() => {
        dispatch(getAllMicroQualifications({
            page: currentPage,
            limit: pageSize,
            role: 'admin'
        }));
    }, []);

    function handleCreate() {
        form.validateFields()
            .then(async (values) => {
                setIsLoadingCreate(true);
                setOpenModal(false)
                await MicroQualificationService.saveMicroqualification(nameRu, nameKz, nameEng)
                    .then(() => {
                        message.success(<IntlMessage id={'success'}/>)
                        form.resetFields();
                    })
                    .catch()
                    .finally()
            })
            .catch((error) => {
                console.log("Validation error!", error);
            })
            .finally(() => {
                setIsLoadingCreate(false);
                message.destroy();
                dispatch(getAllMicroQualifications({
                    page: currentPage,
                    limit: pageSize,
                    role: 'admin'
                }))
            });
    }

    async function downloadDocument(id) {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        await MicroQualificationService.getResource(id)
            .then((r) => {
                message.destroy();
                message.success(<IntlMessage id={'success'}/>, 5);

                triggerDownload(r.data, "act_completion_work.pdf")
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id={'error'}/>, 5);
            })
    }

    function triggerDownload(blob, filename) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Set the download attribute with a filename
        document.body.appendChild(link);
        link.click();

        // Clean up and revoke the URL after download
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    const fetchData = async (params) => {
        return dispatch(getAllMicroQualifications({
            ...params,
            role: 'admin'
        }));
    }

    const saveCurrentPageSettings = (page, pageSize) => {
        dispatch(changeCurrentPage({page: page, pageSize: pageSize}));
    };

    return (
        <Flex style={{width: "100%"}} gap={20} align={"flex-start"} justify={"flex-start"} vertical>
            <MyText uppercase strong size={"large"}><IntlMessage id={'microQualification'}/></MyText>
            {/*<BlackerBlueButton onClick={() => {*/}
            {/*    setOpenModal(true)*/}
            {/*}}>*/}
            {/*    <IntlMessage id={'create'}/>*/}
            {/*</BlackerBlueButton>*/}
            <MyTable
                isLoading={isLoading || isLoadingCreate}
                dataSource={microQualifications}
                columns={columns}
                fetchData={fetchData}
                saveCurrentPage={saveCurrentPageSettings}
                initialPage={currentPage}
                initialPageSize={pageSize}
                hasMore={hasMore}
            />
            <Form form={form} className={classes.form} initialValues={{method: 'group'}}>
                <Modal
                    width={500}
                    maskClosable={true}
                    title={<IntlMessage id={'applicationsPage.comment'}/>}
                    open={openModal}
                    onOk={handleCreate}
                    onCancel={() => {
                        setOpenModal(false)
                    }}
                    okText={<IntlMessage id={'create'}/>}
                    cancelText={<IntlMessage id={'close'}/>}
                >
                    <Flex vertical style={{width: '100%'}} gap={4}>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameRu')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameRu">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameRu"})}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameKz')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameKz">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameKz"})}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameEng')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameEng">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameEng"})}/>
                        </FormItem>
                    </Flex>
                </Modal>
            </Form>
        </Flex>
    );
};

export default MicroQualificationList;